import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from "../components/message-list";

MessageBroker.subscribe(ProductMessages.CHANGED, ({item, itemOption}) => {
    if (!itemOption && item?.itemOptions?.length === 1) {
        itemOption = item.itemOptions[0];
        if (itemOption) {
            MessageBroker.publish(ProductMessages.CHANGED, {item, itemOption});
        }
    }
});
